import React, { FC } from 'react'

import { markAsWixStudioAccount } from '../../../api/StudioWorkspaceService/markAsWixStudioAccount'
import { unmarkAsWixStudioAccount } from '../../../api/StudioWorkspaceService/unmarkAsWixStudioAccount'
import { WixStudioBulletSplit as WixStudioBulletSplitUnwrapped } from './WixStudioBulletSplit'

type WixStudioBulletSplitProps = {}

export const WixStudioBulletSplit: FC<WixStudioBulletSplitProps> = props => {
  return (
    <WixStudioBulletSplitUnwrapped
      {...props}
      markAsWixStudioAccount={markAsWixStudioAccount}
      unmarkAsWixStudioAccount={unmarkAsWixStudioAccount}
    />
  )
}
